/** Roles that may use membership self-serve (plans, checkout, payments, etc.). */
const MEMBERSHIP_MANAGER_ROLES = new Set([
  "COMPANY_ADMIN",
  "PRIMARY_SUPER_ADMIN",
  "SECONDARY_SUPER_ADMIN"
]);

/**
 * True for any non-empty role string that is not in the manager allowlist above.
 * This is allowlist-inversion, not a fixed denylist: new backend role values default
 * to "non-manager" here until added to `MEMBERSHIP_MANAGER_ROLES`.
 */
export const isKnownNonManagerRole = (role: unknown): boolean => {
  if (typeof role !== "string") return false;
  const normalizedRole = role.trim().toUpperCase();
  if (!normalizedRole) return false;
  return !MEMBERSHIP_MANAGER_ROLES.has(normalizedRole);
};
